export class TbaModalsPayload {
  tbaId: number;
}
